/**
 * @param {string} selector
 * @param {ParentNode} context
 */

export const onSelect = (selector, context = document) => context.querySelector(selector)

export const onSelectAll = (selector, context = document) => context.querySelectorAll(selector)

export function getSelector(element, attribute) {
  let selector = element.getAttribute(attribute)

  if (!selector || selector === '#') {
    let hrefAttr = element.getAttribute('href')

    if (!hrefAttr || (!hrefAttr.includes('#') && !hrefAttr.startsWith('.'))) {
      return null
    }

    if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
      hrefAttr = `#${hrefAttr.split('#')[1]}`
    }

    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null
  }

  return selector
}

export function getSelectorFromElement(element, attribute) {
  const selector = getSelector(element, attribute)

  if (selector) {
    return onSelect(selector) ? selector : null
  }

  return null
}
